import { apiClient, unwrap } from '@/lib/api-client';
import type { ApiSuccess } from '@/types/api';

export interface AppNotification {
  id: string;
  subject: string | null;
  body: string;
  /** Alamat yang dibuka saat notifikasi diklik. */
  linkPath: string | null;
  isRead: boolean;
  createdAt: string;
  /** Hanya terisi pada daftar seluruh lembaga. */
  recipientName: string | null;
}

export interface NotificationList {
  items: AppNotification[];
  /** SELALU jumlah belum-dibaca milik pemirsanya sendiri, juga pada daftar lembaga. */
  unreadCount: number;
  total: number;
  page: number;
  perPage: number;
  totalPages: number;
}

interface ListParams {
  page?: number;
  perPage?: number;
  unreadOnly?: boolean;
  /** true = seluruh lembaga (butuh izin `notification.read`). */
  all?: boolean;
}

export const notificationService = {
  list({ all, ...params }: ListParams = {}): Promise<NotificationList> {
    return unwrap(
      apiClient.get<ApiSuccess<NotificationList>>(all ? '/notifications/all' : '/notifications', {
        params,
      }),
    );
  },

  markRead(id: string): Promise<null> {
    return unwrap(apiClient.post<ApiSuccess<null>>(`/notifications/${id}/read`));
  },

  markAllRead(): Promise<{ count: number }> {
    return unwrap(apiClient.post<ApiSuccess<{ count: number }>>('/notifications/read-all'));
  },
};
